import {observer} from 'mobx-react';
import React from 'react';
import s from '../../s';

declare var _atc_orange:boolean;

type Props = {
    loading: boolean;
    label?: string;
    additionalClass?: string;
    clicked: () => Promise<void>;
};

const ATCButtonTemplate: React.FC<Props> = observer(({loading, label: labelProp, additionalClass, clicked}) => {
    const label = labelProp || 'Add to cart';

    return (
        <>
            <div
                aria-live="assertive"
                aria-atomic="true"
                className="sr-only"
            >
                {loading ? 'Adding to cart, please wait...' : ''}
            </div>

            <button
                className={`prod-atc-btn ${additionalClass || ''}${s.IsPortal3 ? ' portal3' : ''}${_atc_orange ? ' atc_orange' : ''}`}
                aria-label={label}
                onClick={clicked}
                disabled={loading}
                aria-busy={loading}
                type="button"
            >
                {label}
                {loading && (
                    <span
                        className="pad-left"
                        aria-hidden="true"
                    >
                        <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                    </span>
                )}
            </button>
        </>
    );
});

export default ATCButtonTemplate;
